module.exports = __webpack_public_path__ + "img/China_Power_80X30.11fa045c.png";